import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    showCreateComputerScienceAssignmentModal: false,
    showCreateTextAssignmentModal: false,
    showGenerateSimilarSubmissionsModal: false,
    showAssignmentPropertiesModal: false,
    showPersonalizationModal: false,
    showAddFilesModal: false,
    showShareAssignmentModal: false,
    showImportModelModal: false,
    showProgressDrawer: false,
    showCreateMbaModal: false,
    showLmsModal: false,
    showDistributeWorkloadModal: false,
    clientAssignmentLastModified: null,
    serverAssignmentLastModified: null,
}

const assignmentSlice = createSlice({
    name: 'assignment',
    initialState,
    reducers: {
        toggleCreateComputerScienceAssignmentModal: state => {
            state.showCreateComputerScienceAssignmentModal = !state.showCreateComputerScienceAssignmentModal
        },
        toggleCreateTextAssignmentModal: state => {
            state.showCreateTextAssignmentModal = !state.showCreateTextAssignmentModal
        },
        toggleAssignmentPropertiesModal: state => {
            state.showAssignmentPropertiesModal = !state.showAssignmentPropertiesModal
        },
        togglePersonalizationModal: state => {
            state.showPersonalizationModal = !state.showPersonalizationModal
        },
        toggleGenerateSimilarSubmissionsModal: state => {
            state.showGenerateSimilarSubmissionsModal = !state.showGenerateSimilarSubmissionsModal
        },
        toggleAddFilesModal: state => {
            state.showAddFilesModal = !state.showAddFilesModal
        },
        toggleShareAssignmentModal: state => {
            state.showShareAssignmentModal = !state.showShareAssignmentModal
        },
        toggleImportModelModal: state => {
            state.showImportModelModal = !state.showImportModelModal
        },
        setShowProgressDrawer: (state, action) => {
            state.showProgressDrawer = action.payload
        },
        setShowCreateMbaModal: (state, action) => {
            state.showCreateMbaModal = action.payload
        },
        setShowLmsModal: (state, action) => {
            state.showLmsModal = action.payload
        },
        setShowDistributeWorkloadModal: (state, action) => {
            state.showDistributeWorkloadModal = action.payload
        },
        setClientAssignmentLastModified: (state, action) => {
            state.clientAssignmentLastModified = action.payload
        },
        setServerAssignmentLastModified: (state, action) => {
            state.serverAssignmentLastModified = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const assignmentActions = assignmentSlice.actions
export const {
    toggleCreateComputerScienceAssignmentModal,
    toggleCreateTextAssignmentModal,
    toggleAssignmentPropertiesModal,
    togglePersonalizationModal,
    toggleGenerateSimilarSubmissionsModal,
    toggleAddFilesModal,
    toggleShareAssignmentModal,
    toggleImportModelModal,
    setClientAssignmentLastModified,
    setServerAssignmentLastModified,
    reset,
} = assignmentSlice.actions

export default assignmentSlice.reducer
